import * as Sentry from "@sentry/angular";
import { onSentryBeforeSend } from "./environment-sentry-config";
import { AppVersion } from "src/app/app-version";

// https://b18115769d1b9b27bf488fa839c1b00f@sentry.creativesoftware.de/9
export const environment = {
  production: true
};


Sentry.init({
  dsn: "https://b18115769d1b9b27bf488fa839c1b00f@sentry.creativesoftware.de/9",
  release: AppVersion.full,
  integrations: [
    Sentry.browserTracingIntegration({
      // tracePropagationTargets is now a top-level option, not inside the integration
    }),
  ],
  // /^\// matches all relative URLs (same-origin /api/... calls); "localhost" covers local dev
  tracePropagationTargets: ["localhost", /^\//],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  //tracesSampleRate: 0.75,
  tracesSampleRate: 1.0, // For now, sample all traces in production, can be changed later but we have so many missing events right now

  beforeSend: onSentryBeforeSend,
});